import { render, staticRenderFns } from "./vatreports.vue?vue&type=template&id=21c4c24d"
import script from "./vatreports.vue?vue&type=script&lang=js"
export * from "./vatreports.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports